export default {
  "widget.defaultTitle": "문의하기",
  "widget.defaultSubtitle": "기꺼이 도와드리겠습니다",
  "widget.defaultGreeting": "안녕하세요! 무엇을 도와드릴까요?",
  "chat.close": "채팅 닫기",
  "chat.open": "채팅 열기",
  "chat.expand": "채팅 확대",
  "chat.collapse": "채팅 축소",
  "chat.conversationEnded": "이 대화가 종료되었습니다",
  "chat.startNew": "새 대화 시작",
  "chat.poweredBy": "Powered by",
  "chat.conversationClosed": "대화 종료됨",
  "chat.aiLabel": "AI 어시스턴트",
  "input.placeholder": "메시지를 입력하세요...",
  "input.send": "메시지 보내기",
  "error.sendFailed": "메시지를 보내지 못했습니다. 잠시 후 다시 시도해 주세요.",
  "error.messageTooLong": "메시지가 너무 깁니다. 줄여서 다시 시도해 주세요.",
  "chat.teamMember": "팀원",
  "chat.agentJoined": "{name}님이 채팅에 참여했습니다",
  "chat.agentLeft": "{name}님이 채팅에서 나갔습니다",
  "chat.agentReturnedToAi": "{name}님이 채팅에서 나갔습니다. 이제 다시 AI 어시스턴트와 대화합니다.",
  "availability.open": "지금 운영 중",
  "availability.backAt": "{when} 복귀",
  "availability.closed": "지금은 운영 시간이 아닙니다",
  "waiting.title": "상담원을 기다리는 중",
  "waiting.typical": "보통 {time} 내 답변",
  "waiting.alerted": "팀에 알렸습니다.",
  "waiting.closed": "팀은 {when}에 돌아옵니다. 그때까지 AI 어시스턴트가 계속 도와드릴 수 있습니다.",
  "waiting.minutes": "약 {n}분",
  "waiting.hours": "약 {n}시간",
  "contact.prompt": "이메일을 남겨 주시면 자리를 비우셨을 때 팀의 답변을 이메일로 보내 드립니다.",
  "contact.label": "이메일",
  "contact.placeholder": "you@example.com",
  "contact.submit": "알림 받기",
  "contact.consent": "이메일은 이 대화에 답변하는 데에만 사용합니다.",
  "contact.saved": "감사합니다! 팀이 답변할 때 자리를 비우셨다면 이메일을 보내 드리겠습니다.",
  "contact.failed": "이메일을 저장하지 못했습니다. 확인 후 다시 시도해 주세요.",
  "input.attach": "사진 또는 PDF 첨부",
  "error.fileTooLarge": "파일이 너무 큽니다. 사진과 PDF는 최대 10MB입니다.",
  "error.fileType": "사진(JPG, PNG, GIF, WebP) 또는 PDF를 보낼 수 있습니다.",
  "error.fileFailed": "파일을 보내지 못했습니다. 다른 파일을 시도해 주세요.",
  "attachment.photo": "사진",
  "attachment.file": "파일",
  "attachment.sending": "보내는 중...",
  "error.verificationFailed": "메시지를 확인하지 못했습니다. 페이지를 새로고침한 후 다시 시도해 주세요.",
  "challenge.label": "보안 확인",
  "challenge.prompt": "메시지를 보내기 전에 간단한 보안 확인을 진행합니다.",
  "csat.defaultQuestion": "오늘 받으신 지원을 어떻게 평가하시겠어요?",
  "csat.thankYou": "의견 주셔서 감사합니다!",
} as const;
